import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '../../quote';
import { QuoteOptInDiscountOutput } from '../../entities/QuoteOptInDiscountOutput';
import ReviewQuoteOptInDiscountsListItem from './ReviewQuoteOptInDiscountsListItem';
import ReviewQuoteProductUseLatestDiscountsModal from '../quote-products/ReviewQuoteProductUseLatestDiscountsModal';

export default class ReviewQuoteOptInDiscountsList extends React.Component {
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    optInDiscounts: PropTypes.arrayOf(PropTypes.instanceOf(QuoteOptInDiscountOutput)).isRequired,
    onToggleDiscount: PropTypes.func.isRequired,
    useLatestDiscounts: PropTypes.bool.isRequired,
    onSetUseLatestDiscounts: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showSetUseLatestDiscountsModal: false,
    };
  }

  hideSetUseLatestDiscountsModal = () =>
    this.setState({ showSetUseLatestDiscountsModal: false });

  render() {
    const { quote, optInDiscounts, onToggleDiscount, useLatestDiscounts, onSetUseLatestDiscounts } = this.props;
    const { showSetUseLatestDiscountsModal } = this.state;

    return (
      <div className="card mb-4 box-shadow municipal-tender">
        <div className="card-body">
          <h6 className="card-title text-center">Discounts</h6>
          <div className="row justify-content-center">
            {!useLatestDiscounts && (
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() =>
                  this.setState({
                    showSetUseLatestDiscountsModal: true,
                  })
                }
              >
                Use Latest Discounts
              </button>
            )}
            {useLatestDiscounts && (
              <div className="text-center text-success"><i className="fa fa-check"></i>&nbsp;Latest discounts are being applied to this quote</div>
            )}
          </div>
          <div className="row mt-2">
            {optInDiscounts.length === 0 && (
              <div className="text-center">
                No discounts are available
              </div>
            )}
            {optInDiscounts.length > 0 && optInDiscounts.map((item, i) => (
              <ReviewQuoteOptInDiscountsListItem
                key={optInDiscounts.length - i}
                quote={quote}
                discount={item}
                onToggleDiscount={onToggleDiscount}
              />
            ))}
          </div>
          <ReviewQuoteProductUseLatestDiscountsModal
            show={showSetUseLatestDiscountsModal}
            onHide={this.hideSetUseLatestDiscountsModal}
            onChanged={onSetUseLatestDiscounts}
          />
        </div>
      </div>
    );
  }
}
